enum TimeboxUnit {
  SECONDS = 5,
  MINUTES = 60,
}

export default TimeboxUnit;
